module.exports = __webpack_public_path__ + "assets/img/liangzi.5661d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/liangzi.png
// module id = 194
// module chunks = 45